// extracted by mini-css-extract-plugin
module.exports = {"container":"orgchart-item-view-type_container__LXg_c"};